import { IModifiedReward } from 'types';

import AcademicYearTitle from '../AcademicYearTitle';
import PdfCommonRewards from '../PdfCommonRewards';

type PdfRewardsByAcademicYearListProps = {
  academicYearData: [string, IModifiedReward[]][];
};

const PdfRewardsByAcademicYearList = ({ academicYearData }: PdfRewardsByAcademicYearListProps) => {
  return academicYearData.map(([academicYear, data]) => (
    <div key={academicYear}>
      <AcademicYearTitle academicYear={academicYear} />
      <PdfCommonRewards rewards={data || []} />
    </div>
  ));
};

export default PdfRewardsByAcademicYearList;
